import React, { useCallback } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { first } from 'lodash';

import ErrorBoundary from 'components/core/ErrorBoundary.component';
import FLAG from 'config/flag.singleton';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import call from 'utils/functions/call.util';
import logger from 'utils/logger.util';
import parseJson from 'utils/parsers/parseJson';
import isFn from 'utils/predicates/function/isFn.util';

const CTAG = 'DndDraggable';
const L = logger(CTAG);

const STRATEGY = 'console';

const DndDraggable = (props) => {
  const tag = fromAnyToTrimmed(props.tag);
  const id = parseJson(props.draggableId);
  const children = isFn(props.children) ? props.children : first(props.children);

  if (FLAG.loggerSpam) L.debug('()', props.index, props.isDragDisabled, id, 'props:', props);

  const wrapper = useCallback(
    (provided, snapshot, ...args) => {
      if (snapshot?.isDragging) L.debug('children()', parseJson(snapshot?.draggingOver), provided, snapshot);
      const prefix = tag ? `${tag}/` : '';
      return call(`${prefix}DndDraggable.children`, children, provided, snapshot, ...args);
    },
    [children, tag],
  );

  if (FLAG.loggerSpam && isFn(children)) {
    return (
      <ErrorBoundary strat={STRATEGY} tag={tag}>
        <Draggable {...props}>{wrapper}</Draggable>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary strat={STRATEGY} tag={tag}>
      <Draggable {...props} />
    </ErrorBoundary>
  );
};

export default DndDraggable;
